"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineNotification = exports.NotificationType = void 0;
const atoms_1 = require("../../atoms");
const react_1 = __importDefault(require("react"));
const getNotificationConfig_1 = require("./getNotificationConfig");
const classnames_1 = __importDefault(require("classnames"));
var NotificationType;
(function (NotificationType) {
    NotificationType["COMPLETED"] = "COMPLETED";
    NotificationType["NEW"] = "NEW";
    NotificationType["WARNING"] = "WARNING";
    // SUCCESS = 'SUCCESS', No designs yet
    // INFO = 'INFO', No designs yet
    // ERROR = 'ERROR', No designs yet
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
const InlineNotification = ({ type, children, arrow, onClick, testId, className, sticky, }) => {
    const config = (0, getNotificationConfig_1.getNotificationConfig)(type);
    if (!config)
        return null;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(config.bg, arrow && 'cursor-pointer', 'rounded-default p-4 mb-10 z-20 ', sticky ? 'sticky top-0 w-full' : 'relative', className), "data-testid": testId, onClick: (e) => {
            if (onClick && arrow)
                onClick(e);
        } },
        react_1.default.createElement("div", { className: "flex items-center justify-between" },
            react_1.default.createElement("div", { className: "flex items-center justify-start" },
                react_1.default.cloneElement(config.icon, { className: 'mr-4' }),
                react_1.default.createElement(atoms_1.Text, { type: atoms_1.TextType.HEADING_S, className: (0, classnames_1.default)(arrow && 'cursor-pointer', 'text-[#151C23]') }, children)),
            arrow && !config.noIcon && (react_1.default.createElement(atoms_1.Icon.ArrowRight, { className: "text-[#151C23]", height: "20", width: "20" })))));
};
exports.InlineNotification = InlineNotification;
//# sourceMappingURL=InlineNotification.js.map